export default __webpack_public_path__ + "static/media/detailsIcon.4061595b.svg";